import { render } from "./MentionsLegalesForm2.vue?vue&type=template&id=25878f8f&ts=true"
import script from "./MentionsLegalesForm2.vue?vue&type=script&lang=ts"
export * from "./MentionsLegalesForm2.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__